export enum CybermetrieEnum {
  CATEGORIE_TRANSACTION = 'Transaction',
  CATEGORY_INTERACTIONS_FORMES = 'Interractions forms',
  CATEGORIE_GESTION_COORDONNEES = 'Gestion coordonnees',
  CATEGORIE_ERREUR = 'Erreur',

  ACTION_CLIC = 'Clic',
  ACTION_DEBUTE = 'debute',
  ACTION_DETENTION_ASSURANCE = 'debute | detention assurance | saisis',
  ACTION_ADRESSE_ASSURANCE = 'debute | adresse assurance | saisis',
  ACTION_PREFERENCE_CONTACT = 'debute | preference contact | saisis',
  ACTION_PREFERENCE_HEURE = 'debute | preference heure | saisis',
  ACTION_ETAPE = 'etape-2',
  ACTION_COMPLETE = 'complete',
  ACTION_ERREUR_TECHNIQUE = 'erreur technique',
  ACTION_ERREUR_UTILISATEUR = 'erreur utilisateur',
  ACTION_EOF = 'eof',

  LABEL_MODIFIER_COORDONNEES = 'modifier coordonnees - utilisation coordonnees ',
  LABEL_MODIFIER_COORDONNEES_ADRESSE = 'modifier coordonnees - adresse principale',
  LABEL_MODIFIER_COORDONNEES_TELEPHONE_MODIFIER = 'modifier coordonnees - telephone',
  LABEL_MODIFIER_COORDONNEES_TELEPHONE_AJOUTER = 'ajouter coordonnees - telephone',
  LABEL_MODIFIER_COORDONNEES_COURRIEL_MODIFIER = 'modifier coordonnees - courriel',
  LABEL_MODIFIER_COORDONNEES_COURRIEL_AJOUTER = 'ajouter coordonnees - courriel',
  LABEL_MODIFIER_COORDONNEES_PLANIFIER_APPEL = 'modifier coordonnees - planifier un appel',
  LABEL_MODIFIER_COORDONNEES_NOUS_JOINDRE = 'modifier coordonnees - nous joindre - eof',
  LABEL_MODIFIER_COORDONNEES_ERREUR = 'modifier coordonnees - erreur',

  LABEL_MODIFIER_ADRESSE = 'trx - modifier coordonnees - adresse',
  LABEL_MODIFIER_ADRESSE_DGAG = 'modifier coordonnees - adresse principale - ',
  LABEL_MODIFIER_ADRESSE_VALIDATION = 'modifier coordonnees - validation - modifier adresse',
  LABEL_MODIFIER_ADRESSE_NOUS_JOINDRE = 'modifier coordonnees - nous joindre - adresse',

  LABEL_MODIFIER_TELEPHONE = 'trx - modifier coordonnees - telephone',
  LABEL_MODIFIER_TELEPHONE_AJOUT = 'trx - modifier coordonnees - ajout telephone',
  LABEL_MODIFIER_TELEPHONE_VALIDATION = 'modifier coordonnees - validation - modifier telephone',
  LABEL_MODIFIER_TELEPHONE_NOUS_JOINDRE = 'modifier coordonnees - nous joindre - telephone',

  LABEL_MODIFIER_COURRIEL = 'trx - modifier coordonnees - courriel',
  LABEL_MODIFIER_COURRIEL_AJOUT = 'trx - modifier coordonnees - ajout courriel',
  LABEL_MODIFIER_COURRIEL_VALIDATION = 'modifier coordonnees - validation - modifier courriel',
  LABEL_MODIFIER_COURRIEL_NOUS_JOINDRE = 'modifier coordonnees - nous joindre - courriel',

  EXTRA_ATTRIBUT = 'extraAttribut',
  EXTRA_ATTRIBUT_2 = 'extraAttribut2',
  EXTRA_ATTRIBUT_ADRESSE_POSTDATEE = 'adresse postdatee',
  EXTRA_ATTRIBUT_ADRESSE_NON_MODIFIABLE = 'adresse non modifiable',
  EXTRA_ATTRIBUT_DGAG_APPARIE = 'apparie',
  EXTRA_ATTRIBUT_DGAG_NON_APPARIE = 'non apparie',
  EXTRA_ATTRIBUT_ADRESSE = 'adresse',
  EXTRA_ATTRIBUT_ASSURANCE = 'assurance',
  EXTRA_ATTRIBUT_CONFIRME = 'confirme',
  EXTRA_ATTRIBUT_APPEL_PLANIFIE = 'appel planifie',
  EXTRA_ATTRIBUT_APPEL_REQUIS = 'appel requis',
  EXTRA_ATTRIBUT_PARTIEL = 'partiel',
  EXTRA_ATTRIBUT_PARTIEL_APPEL_PLANIFIE = 'partiel appel planifie',
  EXTRA_ATTRIBUT_PARTIEL_APPEL_REQUIS = 'partiel appel requis',

  MESSAGE_ERREUR = 'messageErreur',
}
